[
  {
    "id": "TOPO-HOOFDSTAD-M6P-L104-001",
    "module": "Topo",
    "difficulty": 104,
    "difficultyTier": 4,
    "levelCode": "M6+",
    "group": 6,
    "question": "Leeuwarden is de hoofdstad van welke provincie?",
    "options": ["Friesland", "Groningen", "Drenthe", "Flevoland"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "provincies",
    "subSkill": "nederland",
    "familyId": "TOPO-NL-PROVINCIE-HOOFDSTAD",
    "conceptId": "province_capital_match",
    "variantIndex": 1,
    "explanation": "Leeuwarden hoort bij Friesland. Denk aan ‘Fryslân’ (Friesland) met Leeuwarden als hoofdstad.",
    "distractorExplanations": {
      "1": "Groningen (provincie) heeft Groningen (stad) als hoofdstad. Leeuwarden ligt westelijker dan Groningen.",
      "2": "Drenthe heeft Assen als hoofdstad. Leeuwarden ligt niet in Drenthe.",
      "3": "Flevoland heeft Lelystad als hoofdstad. Leeuwarden ligt in het noorden aan de kant van Friesland."
    }
  },
  {
    "id": "TOPO-HOOFDSTAD-M6P-L104-002",
    "module": "Topo",
    "difficulty": 104,
    "difficultyTier": 4,
    "levelCode": "M6+",
    "group": 6,
    "question": "Maastricht is de hoofdstad van welke provincie?",
    "options": ["Noord-Brabant", "Limburg", "Gelderland", "Zeeland"],
    "correctAnswer": 1,
    "questionType": "multiple_choice",
    "skill": "provincies",
    "subSkill": "nederland",
    "familyId": "TOPO-NL-PROVINCIE-HOOFDSTAD",
    "conceptId": "province_capital_match",
    "variantIndex": 2,
    "explanation": "Maastricht is de hoofdstad van Limburg. Limburg ligt helemaal in het zuiden van Nederland.",
    "distractorExplanations": {
      "0": "Noord-Brabant heeft ’s-Hertogenbosch (Den Bosch) als hoofdstad, niet Maastricht.",
      "2": "Gelderland heeft Arnhem als hoofdstad. Maastricht ligt veel zuidelijker.",
      "3": "Zeeland heeft Middelburg als hoofdstad en bestaat uit (schier)eilanden in het zuidwesten."
    }
  },
  {
    "id": "TOPO-RIVIER-M6P-L104-003",
    "module": "Topo",
    "difficulty": 104,
    "difficultyTier": 4,
    "levelCode": "M6+",
    "group": 6,
    "question": "Welke rivier stroomt langs Nijmegen?",
    "options": ["Waal", "IJssel", "Maas", "Vecht"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "rivieren",
    "subSkill": "nederland",
    "familyId": "TOPO-NL-RIVIER-STAD",
    "conceptId": "river_city_match",
    "variantIndex": 1,
    "explanation": "Nijmegen ligt aan de Waal. De Waal is een belangrijke tak van de Rijn in Nederland.",
    "distractorExplanations": {
      "1": "De IJssel stroomt richting het IJsselmeer (langs o.a. Deventer en Zwolle), niet langs Nijmegen.",
      "2": "De Maas stroomt o.a. langs Maastricht en Den Bosch. Nijmegen ligt aan de Waal, niet aan de Maas.",
      "3": "De Vecht ligt vooral in Utrecht/Overijssel. Nijmegen ligt daar niet aan."
    }
  },
  {
    "id": "TOPO-RIVIER-M6P-L104-004",
    "module": "Topo",
    "difficulty": 104,
    "difficultyTier": 4,
    "levelCode": "M6+",
    "group": 6,
    "question": "De IJssel mondt uit in…",
    "options": ["het IJsselmeer", "de Noordzee", "de Waddenzee", "de Maas"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "rivieren",
    "subSkill": "nederland",
    "familyId": "TOPO-NL-RIVIER-MONDT_UIT",
    "conceptId": "river_mouth_match",
    "variantIndex": 1,
    "explanation": "De IJssel stroomt naar het noorden en komt uit in het IJsselmeer. Dat kun je ook aan de naam koppelen: IJssel → IJsselmeer.",
    "distractorExplanations": {
      "1": "Veel rivieren eindigen bij zee, maar de IJssel eindigt in het IJsselmeer (binnenwater), niet direct in de Noordzee.",
      "2": "De Waddenzee ligt boven Nederland, maar de IJssel komt eerst in het IJsselmeer uit.",
      "3": "De IJssel is een tak van de Rijn en stroomt niet ‘naar’ de Maas toe om daarin uit te monden."
    }
  },
  {
    "id": "TOPO-KAART-M6P-L104-005",
    "module": "Topo",
    "difficulty": 104,
    "difficultyTier": 4,
    "levelCode": "M6+",
    "group": 6,
    "question": "Je reist van Utrecht naar Arnhem. In welke richting ga je vooral?",
    "options": ["Oost", "West", "Noord", "Zuid"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "kaartvaardigheid",
    "subSkill": "nederland",
    "familyId": "TOPO-NL-KAART-RICHTING_STEDEN",
    "conceptId": "direction_between_cities",
    "variantIndex": 1,
    "explanation": "Arnhem ligt rechts (oostelijk) van Utrecht op de kaart van Nederland. Dus je gaat vooral naar het oosten.",
    "distractorExplanations": {
      "1": "West is richting de kust (Noordzee). Arnhem ligt juist landinwaarts aan de oostkant.",
      "2": "Noord kan een klein beetje lijken, maar de grootste beweging is naar rechts: oost.",
      "3": "Zuid is richting Brabant/Limburg. Arnhem ligt niet onder Utrecht, maar vooral oostelijk."
    }
  },
  {
    "id": "TOPO-PROVINCIE-M6P-L104-006",
    "module": "Topo",
    "difficulty": 104,
    "difficultyTier": 4,
    "levelCode": "M6+",
    "group": 6,
    "question": "Welke provincie grenst aan zowel België als Duitsland?",
    "options": ["Limburg", "Zuid-Holland", "Overijssel", "Friesland"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "provincies",
    "subSkill": "nederland",
    "familyId": "TOPO-NL-PROVINCIE-GRENZEN",
    "conceptId": "province_border_reasoning",
    "variantIndex": 1,
    "explanation": "Limburg ligt als een ‘vinger’ in het zuiden en raakt aan de ene kant België en aan de andere kant Duitsland.",
    "distractorExplanations": {
      "1": "Zuid-Holland ligt aan de Noordzee en grenst niet aan Duitsland.",
      "2": "Overijssel grenst wel aan Duitsland, maar niet aan België.",
      "3": "Friesland ligt in het noorden en grenst niet aan België of Duitsland."
    }
  },
  {
    "id": "TOPO-KAART-M6P-L104-007",
    "module": "Topo",
    "difficulty": 104,
    "difficultyTier": 4,
    "levelCode": "M6+",
    "group": 6,
    "question": "Texel hoort bij welke provincie?",
    "options": ["Noord-Holland", "Friesland", "Groningen", "Zeeland"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "kaartvaardigheid",
    "subSkill": "nederland",
    "familyId": "TOPO-NL-EILAND-PROVINCIE",
    "conceptId": "island_province_match",
    "variantIndex": 1,
    "explanation": "Texel ligt boven Noord-Holland en hoort bij de provincie Noord-Holland.",
    "distractorExplanations": {
      "1": "Friesland heeft ook Waddeneilanden (zoals Terschelling en Ameland), maar Texel hoort bij Noord-Holland.",
      "2": "Groningen ligt in het noordoosten. Het heeft geen Texel als eiland in de provincie.",
      "3": "Zeeland ligt in het zuidwesten en heeft andere eilanden/schiereilanden (zoals Walcheren), niet Texel."
    }
  },
  {
    "id": "TOPO-KAART-M6P-L104-008",
    "module": "Topo",
    "difficulty": 104,
    "difficultyTier": 4,
    "levelCode": "M6+",
    "group": 6,
    "question": "Welke uitspraak klopt het best?",
    "options": [
      "De Waddenzee ligt tussen de Waddeneilanden en het Nederlandse vasteland.",
      "De Waddenzee ligt ten westen van Ierland.",
      "De Waddenzee is een rivier die door Duitsland stroomt.",
      "De Waddenzee ligt tussen België en Frankrijk."
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "kaartvaardigheid",
    "subSkill": "nederland",
    "familyId": "TOPO-NL-WATER-WADDENZEE_CONCEPT",
    "conceptId": "wadden_sea_location_concept",
    "variantIndex": 1,
    "explanation": "De Waddenzee is het ondiepe watergebied boven Nederland, tussen de eilanden (zoals Texel, Terschelling) en het vasteland.",
    "distractorExplanations": {
      "1": "Ten westen van Ierland ligt de Atlantische Oceaan, niet de Waddenzee.",
      "2": "Een zee is geen rivier. De Waddenzee is een kustzeegebied, niet een stroom.",
      "3": "Tussen België en Frankrijk ligt geen Waddenzee; dat is een ander deel van Europa."
    }
  }
]
